export const ACCEPTED_IMAGE_TYPES = '.jpeg,.jpg,.png,.webp,.gif';
export const ACCEPTED_FILE_TYPES = 'application/pdf';
export const ACCEPTED_GEOJSON_TYPES = '.json, .geojson';
export const MAIN_CONTAINER_ID = 'main-container';
